import { observer } from 'mobx-react';
import { Alert, Text } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

export const RRError = observer(() => {
  const { t } = useTranslations(translations);

  return (
    <Alert tone="caution">
      <Text>{t('Some screening questions are currently unavailable...')}</Text>
    </Alert>
  );
});
